import React, { useEffect, useState } from "react";
import { API_ENDPOINTS } from "../config/api";

const RESULTS_PER_PAGE = 100;

const Corrections: React.FC = () => {
  const [corrections, setCorrections] = useState<any[]>([]);
  const [startDate, setStartDate] = useState<string>(localStorage.getItem("correctionsStartDate") || "");
  const [endDate, setEndDate] = useState<string>(localStorage.getItem("correctionsEndDate") || "");
  const [currentPage, setCurrentPage] = useState(1);

  const fetchCorrections = async (start?: string, end?: string) => {
    const username = localStorage.getItem("username");
    const password = localStorage.getItem("password");

    if (!username || !password) return;

    const url = new URL(API_ENDPOINTS.corrections);
    if (start) url.searchParams.append("start_date", start);
    if (end) url.searchParams.append("end_date", end);

    try {
      const res = await fetch(url.toString(), {
        method: "POST",  // ✅ Required when using body
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ username, password }),  // ✅ Supported by verify_auth
      });

      const json = await res.json();
      console.log("📝 Corrections fetched:", json);

      if (Array.isArray(json)) {
        setCorrections(json);
      } else if (Array.isArray(json.data)) {
        setCorrections(json.data);
      } else {
        console.error("Unexpected response format:", json);
        setCorrections([]);
      }

      setCurrentPage(1); // Reset to page 1 after new fetch
    } catch (err) {
      console.error("❌ Error fetching corrections:", err);
    }
  };


  useEffect(() => {
    fetchCorrections(startDate, endDate);
  }, []);

  useEffect(() => {
    localStorage.setItem("correctionsStartDate", startDate);
    localStorage.setItem("correctionsEndDate", endDate);
    fetchCorrections(startDate, endDate);
  }, [startDate, endDate]);

  const downloadCSV = () => {
    if (corrections.length === 0) return;

    const headers = Object.keys(corrections[0]);
    const rows = corrections.map((row) =>
      headers.map((key) => JSON.stringify(row[key] || "")).join(",")
    );
    const csvContent = [headers.join(","), ...rows].join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.setAttribute("download", "corrections.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const paginatedData = Array.isArray(corrections)
    ? corrections.slice((currentPage - 1) * RESULTS_PER_PAGE, currentPage * RESULTS_PER_PAGE)
    : [];

  return (
    <div className="max-w-6xl mx-auto bg-white p-6 rounded shadow">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-bold">Field Corrections</h2>
        <button
          onClick={downloadCSV}
          className="bg-[#001d3d] text-white px-3 py-1 rounded text-sm hover:opacity-90"
        >
          Download CSV
        </button>
      </div>

      {/* Date Range Filter */}
      <div className="flex gap-4 mb-4">
        <div>
          <label className="block text-sm font-semibold">Start Date (by call start)</label>
          <input
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            className="border px-2 py-1 text-sm rounded"
          />
        </div>
        <div>
          <label className="block text-sm font-semibold">End Date (by call start)</label>
          <input
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            className="border px-2 py-1 text-sm rounded"
          />
        </div>
      </div>

      {corrections.length === 0 ? (
        <p className="text-gray-500">No corrections found or failed to fetch.</p>
      ) : (
        <>
          <div className="overflow-x-auto">
            <table className="table-auto w-full border text-sm">
              <thead className="bg-gray-100">
                <tr>
                  {Object.keys(corrections[0]).map((k) => (
                    <th key={k} className="border px-2 py-1 text-left font-semibold">
                      {k}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {paginatedData.map((row, i) => (
                  <tr key={i}>
                    {Object.values(row).map((val, j) => (
                      <td key={j} className="border px-2 py-1">
                        {String(val)}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          {corrections.length > RESULTS_PER_PAGE && (
            <div className="flex justify-center mt-4 space-x-4">
              {Array.from({ length: Math.ceil(corrections.length / RESULTS_PER_PAGE) }).map((_, idx) => (
                <button
                  key={idx}
                  className={`px-3 py-1 rounded ${currentPage === idx + 1 ? "bg-[#001d3d] text-white" : "bg-gray-200"}`}
                  onClick={() => setCurrentPage(idx + 1)}
                >
                  {idx + 1}
                </button>
              ))}
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default Corrections;


